import './hireNewCreditCardInformationCcStep1.scss';
import React, { useState } from 'react';
import { i18n } from 'core/i18n';
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
import { OKMessage } from 'commonsComponents/OKMessage';
import BlockInfo from 'components/contactCenter/blockInfo/blockInfo';
import { HireInformation } from 'components/hire/hireInformation/hireInformation';
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';
const { FormattedText, formatText } = i18n;

export const HireNewCreditCardInformationCcStep1 = ({
    getContextTranslate,
    hireCmsKey,
    collectiveLocation,
    immHireInformation,
    onCheckboxChange
}) => {
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsCheckboxChecked(checked);
        onCheckboxChange(checked);
    };

    const renderConditionalContent = () => {
        if (!__CONTACT_CENTER__) {
            return null;
        }

        if (isPrintOfficeMode()) {
            return (
                <OKMessage type="informative">
                    <FormattedText value="ofi_hireNewCreditCard-agentInformation_stepOne" />
                </OKMessage>
            );
        }

        return (
            <BlockInfo>
                <p className="requiredReading">
                    <FormattedText value="cc_hireNewCreditCard-requiredReading" />
                </p>
                <FormattedText value="cc_hireNewCreditCard-agentInformation_stepOne" />
            </BlockInfo>
        );
    };

    const confirmationAgentLabel = <FormattedText value="cc_hireNewCreditCard-confirmationAgentLabel" />

    return (
        <article className="hire-new-credit-cards-cc">
            <FormattedText
                className="hire-card-neruda__step-title"
                value={getContextTranslate('step1Title')}
            />
            <HireInformation
                hireCmsKey={hireCmsKey}
                immHireInformation={immHireInformation}
                collectiveEnabled={!!collectiveLocation}
                collectiveLocation={collectiveLocation}
            />
            {renderConditionalContent()}
            <BlockInfo>
                <p className="requiredReading">
                    {isPrintOfficeMode() ?
                        <FormattedText value="cc_hireNewCreditCard-requiredReadingOfcine" />

                        :
                        <FormattedText value="cc_hireNewCreditCard-requiredReading" />

                    }
                </p>
                <FormattedText value={getContextTranslate('agentInformation_stepOne')} />
            </BlockInfo>
            <OKCheckbox
                idName="hireNewCreditCardAgentConfirmationStepOne"
                label={confirmationAgentLabel}
                onChange={handleCheckboxChange}
                value={isCheckboxChecked}
            />
        </article>
    );
};
